import { render, staticRenderFns } from "./TifGraficosGeneralIndex.vue?vue&type=template&id=15611e97"
import script from "./TifGraficosGeneralIndex.vue?vue&type=script&lang=js"
export * from "./TifGraficosGeneralIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports